import { Component, EventEmitter, HostListener, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { UserService } from "../../services/userService";
import { User } from "../../objects/users/user";
import { PaginationInstance } from "ngx-pagination";
import { UserSearchRequest } from "../../objects/requests/userSearchRequest";
import { AgentModalComponent } from "./modal/agent-modal.component";
import { ModalDirective } from "ngx-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { SearchResponse } from "../../objects/responses/searchResponse";
import { Group } from "../../objects/groups/group";
import { StorageManager } from "../../common/managers/storageManager";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { ConfigService } from "../../services/configService";
import { BlurUtil } from "../../common/utils/blurUtil";
/**
 * Created by vlad.p on 7/31/2017.
 */

@Component({
    selector: 'agent',
    templateUrl: 'agent-management.component.html',
    moduleId: module.id.toString()
})
export class AgentManagementComponent implements OnInit {

    @ViewChild('agentModal') agentModalComponent: AgentModalComponent;

    public query: string;

    public agents: User[] = [];
    public groups: Group[] = [];

    public currentUser: User;

    public idToBlur: string = "agent-management";

    public config: PaginationInstance = {
        id: 'custom',
        itemsPerPage: 12,
        currentPage: 1,
        totalItems: 1
    };

    constructor(private route: ActivatedRoute, public userService: UserService, private storageManager: StorageManager,
                private configService: ConfigService, private router: Router) {

    }

    @HostListener('window:popstate', ['$event'])
    unBlurMenu(): void {
        BlurUtil.unBlurMenu(this.idToBlur);
    }

    public ngOnInit(): void {
        this.config.totalItems = this.route.snapshot.data.agents.TotalCount;
        this.agents = this.route.snapshot.data.agents.Items;
        this.groups = this.route.snapshot.data.groups.Data;


        this.route.params.subscribe(params => {
            let id = params['id'];

            if (id)
                this.storageManager.getCurrentUser().then(x => {
                    this.agentModalComponent.show(x);
                    this.router.navigate(['management/agent']);
                });

        });
    }

    public search(): void {
        this.userService.search(new UserSearchRequest({
            Skip: (this.config.currentPage - 1) * this.config.itemsPerPage,
            Top: this.config.itemsPerPage,
            Query: this.query,
            FillOrders: true
        })).then(users => {
            this.agents = users.Data.Items;
            this.config.totalItems = users.Data.TotalCount;

            document.getElementById('mainPanel').scrollTop = 0;
        }).catch(response => {
            this.agents.splice(0, this.agents.length);
        });
    }

    public createAgent(): void {
        this.agentModalComponent.show(new User());
    }

    public onAgentSaved(agent: User): void {
        let existingAgent = this.agents.find(x => x.Id == agent.Id);

        if (existingAgent != null) {
            agent.Orders = existingAgent.Orders;
            Object.assign(existingAgent, agent);

            this.storageManager.getCurrentUser().then(y => {
                if (y.Id == existingAgent.Id) {
                    this.storageManager.setCurrentUser(existingAgent);
                    window.location.reload();
                }
            });
        } else {
            this.agents.unshift(agent);

            if (this.agents.length > this.config.itemsPerPage)
                this.agents.pop();

            this.config.totalItems += 1;
        }
    }

}


// WEBPACK FOOTER //
// ./app/components/agent/agent-management.component.ts